import React from "react"
import { Helmet } from "react-helmet"
import Layout from "../../../components/Layout"
import Header from "../../../components/Header"
import CaseStudy, {
  CASE_STUDY_TYPES,
} from "../../../components/case-study/CaseStudy"
import ThumbnailImage from "../../../images/thumbnails/gtech.png"
import MagicWithUs from "../../../components/inner-page/MagicWithUs"

export function Index() {
  return (
    <Layout
      title="GTech Marathon Kerala – AI-Driven Photo Delivery Success with Premagic"
      description="Discover how GTech Marathon Kerala delivered 10,000+ runner photos in 2 hours via WhatsApp using AI face recognition and Premagic’s automated sports event photo distribution."
      metaImage={ThumbnailImage}
      keywords={[
        "GTech Marathon Kerala, Kerala marathon photos, Kochi running event, marathon AI technology, sports event photo sharing, running photo delivery, Kerala IT marathon, GTech Kerala case study, marathon photography automation, sports photo distribution, Kerala tech companies, running event management, marathon participant photos, sports event technology, Kerala corporate marathon, automated photo distribution",
      ]}
      breadcrumbs={[
        { name: "Home", url: "/" },
        { name: "Case Studies", url: "/case-study/" },
        { name: "GTech Marathon Kerala", url: "/case-study/gtech/" },
      ]}
    >
      <Helmet>
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "Article",
            "headline": "GTech Marathon Kerala - AI-Driven Photo Delivery Success with Premagic",
            "description": "Discover how GTech Marathon Kerala delivered 10,000+ runner photos in 2 hours via WhatsApp using AI face recognition and Premagic’s automated sports event photo distribution.",
            "image": "https://premagic.com" + ThumbnailImage,
            "author": {
              "@type": "Organization",
              "name": "Premagic",
            },
            "publisher": {
              "@type": "Organization",
              "name": "Premagic",
              "logo": {
                "@type": "ImageObject",
                "url": "https://premagic.com/icons/icon-144x144.png",
              },
            },
            "datePublished": "2024-01-15",
            "dateModified": "2025-01-15",
          })}
        </script>
      </Helmet>
      <Header />
      <CaseStudy type={CASE_STUDY_TYPES.GTECH} />
    </Layout>
  )
}

export default Index
